const mockMusicLinksData = [
  {
    url_part1: 9,
    url_part2: "abcd",
    preview_files: [
      {
        track_name: "WHISTLE",
        artist_name: "Deborah de Luca",
        url: "https://p.scdn.co/mp3-preview/695135c33278a2787a4353fd940671af8e21d6b4?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Deborah de Luca",
    release_name: "WHISTLE",
    ean: "4255899241799",
    image_big: "https://i.scdn.co/image/ab67616d0000b273a1b32503149cf6bc2fddf063",
    image_small: "https://i.scdn.co/image/ab67616d00004851a1b32503149cf6bc2fddf063",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - WHISTLE",
      header_color: "#1f6feb",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#a8c644",
        second_color: "#5d7324",
        direction: 6,
      },
      title_color: "#ffffff",
      description_color: "#ffffff",
      button_color: "#5d7324",
      button_text_color: "#ffffff",
      player_controls_color: "#5d7324",
      created_by: 1001,
      id: "custom-ml-11",
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B0G7FVF2L5",
    applemusic_url: "https://music.apple.com/album/1861740647",
    beatport_url: "https://www.beatport.com/release/whistle/5723415/",
    deezer_url: "https://www.deezer.com/album/878313842",
    spotify_url: "https://open.spotify.com/album/2bdbSdorrDFwR5qR7oDh4W",
    traxsource_url: "https://www.traxsource.com/title/2682884/whistle",
    youtube_url: "https://music.youtube.com/playlist?list=OLAK5uy_m8NBEc1uo1X4r3QcLRfi_Y9uIdIHPh18k",
    id: 11,
    image: "https://i.scdn.co/image/ab67616d00004851a1b32503149cf6bc2fddf063",
    url_part1_name: "soltx",
    url: "https://musiclink.io/l/soltx/abcd",
    created: "2026-05-14T09:46:31.288Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#1f6feb",
    header_gradient: {
      first_color: "#a8c644",
      second_color: "#5d7324",
      direction: 6,
    },
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#5d7324",
    button_text_color: "#ffffff",
    player_controls_color: "#5d7324",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 10,
    url_part2: "fun",
    preview_files: [
      {
        track_name: "No Fun",
        artist_name: "Armin van Buuren, The Stickmen Project",
        url: "https://p.scdn.co/mp3-preview/ec3e8f49164b4a1b9c7599ad7dc6d759440bbdda?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Armin van Buuren, The Stickmen Project",
    release_name: "No Fun",
    ean: "8718522359293",
    image_big: "https://i.scdn.co/image/ab67616d0000b273bf39adf53b72157c93f99b23",
    image_small: "https://i.scdn.co/image/ab67616d00004851bf39adf53b72157c93f99b23",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - No Fun",
      header_color: "#1f6feb",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#2156a3",
        second_color: "#d73574",
        direction: 1,
      },
      title_color: "#ffffff",
      description_color: "#ffffff",
      button_color: "#d73574",
      button_text_color: "#2156a3",
      player_controls_color: "#d73574",
      created_by: 1001,
      id: "custom-ml-12",
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B09KHM51TX",
    applemusic_url: "https://music.apple.com/album/1722588567",
    deezer_url: "https://www.deezer.com/album/268477852",
    spotify_url: "https://open.spotify.com/album/5MOMnX1NgMpjRD0iAHcttM",
    youtube_url: "https://www.youtube.com/watch?v=Y0WKYF0Nnog",
    id: 12,
    image: "https://i.scdn.co/image/ab67616d00004851bf39adf53b72157c93f99b23",
    url_part1_name: "wave",
    url: "https://musiclink.io/l/wave/fun",
    created: "2026-04-27T10:30:47.299Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#1f6feb",
    header_gradient: {
      first_color: "#2156a3",
      second_color: "#d73574",
      direction: 1,
    },
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#d73574",
    button_text_color: "#2156a3",
    player_controls_color: "#d73574",
    beatport_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 5,
    url_part2: "follow",
    preview_files: [
      {
        track_name: "Follow",
        artist_name: "Martin Garrix, Zedd",
        url: "https://p.scdn.co/mp3-preview/a68c333773bc5d1c4794e615a7c8783ce8b4ba6f?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Martin Garrix, Zedd",
    release_name: "Follow",
    ean: "8720623451691",
    image_big: "https://i.scdn.co/image/ab67616d0000b27317358352e5cdfa08af5f2a08",
    image_small: "https://i.scdn.co/image/ab67616d0000485117358352e5cdfa08af5f2a08",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - Follow",
      header_color: "#1f6feb",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#ff6900",
        second_color: "#000000",
        direction: 6,
      },
      title_color: "#ffffff",
      description_color: "#ffffff",
      button_color: "#ff6900",
      button_text_color: "#000000",
      player_controls_color: "#ff6900",
      created_by: 1001,
      id: "custom-ml-13",
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B09V5B2GXL",
    applemusic_url: "https://music.apple.com/album/1621522781",
    deezer_url: "https://www.deezer.com/album/301445427",
    spotify_url: "https://open.spotify.com/album/0mHq8oTwln3MA72n3uHscJ",
    youtube_url: "https://www.youtube.com/watch?v=XR6oVdfz-pg",
    id: 13,
    image: "https://i.scdn.co/image/ab67616d0000485117358352e5cdfa08af5f2a08",
    url_part1_name: "sthx",
    url: "https://musiclink.io/l/sthx/follow",
    created: "2026-04-08T10:32:00.306Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#1f6feb",
    header_gradient: {
      first_color: "#ff6900",
      second_color: "#000000",
      direction: 6,
    },
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#ff6900",
    button_text_color: "#000000",
    player_controls_color: "#ff6900",
    beatport_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 10,
    url_part2: "lsn",
    preview_files: [
      {
        track_name: "Party Horse",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/7bdfa9df34e7d864bebd8c1a60a6e97a20d8d04a?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Lesson Of Hardcore",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/58b125c0b013055d298515f61e810c8a565460d8?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Go Move",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/b932ad67ac2a7fd6005566df3bc1de249987d606?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Time To Fly",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/f399876fdcbb92939e16f6fa7c10f2bbcf483d4d?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Number 1",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/473cf30cdcde77ecbccdc14df8d060849d3b7580?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "The Future",
        artist_name: "Bruno Oliver",
        url: "https://p.scdn.co/mp3-preview/681a554b3695b33d59905c424be93647679e9148?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Bruno Oliver",
    release_name: "Lesson Of Hardcore",
    ean: "5054285600177",
    image_big: "https://i.scdn.co/image/ab67616d0000b273e098e140124f0f9241e5bd5b",
    image_small: "https://i.scdn.co/image/ab67616d00004851e098e140124f0f9241e5bd5b",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      id: "custom-ml-14",
      name: "Colors for Music Link - Lesson Of Hardcore",
      header_color: "#ff40a4",
      header_color_scheme: 1,
      header_gradient: null,
      title_color: "#000000",
      description_color: "#000000",
      button_color: "#ff40a4",
      button_text_color: "#000000",
      player_controls_color: "#ff40a4",
      created_by: 1001,
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B08SJFNS1G",
    applemusic_url: "https://music.apple.com/album/1548068804",
    beatport_url: "https://www.beatport.com/release/lesson-of-hardcore/3250056/",
    spotify_url: "https://open.spotify.com/album/78IN3DHWRsTgs7OjiEOKlJ",
    youtube_url: "https://www.youtube.com/watch?v=4MT8Ss-P1ss",
    id: 14,
    image: "https://i.scdn.co/image/ab67616d00004851e098e140124f0f9241e5bd5b",
    url_part1_name: "wave",
    url: "https://musiclink.io/l/wave/lsn",
    created: "2026-03-22T10:33:34.464Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 1,
    header_color: "#ff40a4",
    header_gradient: {
      id: 1,
      first_color: "#1f6feb",
      second_color: "#0ea5e9",
      direction: 2,
    },
    title_color: "#000000",
    description_color: "#000000",
    button_color: "#ff40a4",
    button_text_color: "#000000",
    player_controls_color: "#ff40a4",
    deezer_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 4,
    url_part2: "evo",
    preview_files: [
      {
        track_name: "Acid Headbreaker",
        artist_name: "Alexander Olck, Chris van Neu",
        url: "https://p.scdn.co/mp3-preview/a5eeb6cafcec06e4a053c166fafc894ace88b2b4?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Evolution",
        artist_name: "Alexander Olck, Chris van Neu",
        url: "https://p.scdn.co/mp3-preview/dc488dee3b6b1a02ced26c3a140f22afa8bfb154?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Evolution - Epicx Remix",
        artist_name: "Alexander Olck, Chris van Neu, Epicx",
        url: "https://p.scdn.co/mp3-preview/e7fe48621ac946b811c52bbf2aa17dc82c79b360?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Alexander Olck, Chris van Neu",
    release_name: "Evolution",
    ean: "5054286316886",
    image_big: "https://i.scdn.co/image/ab67616d0000b27305e9afee53ebf75a70ef15f6",
    image_small: "https://i.scdn.co/image/ab67616d0000485105e9afee53ebf75a70ef15f6",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - Evolution",
      header_color: "#111827",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#226384",
        second_color: "#0a0a14",
        direction: 3,
      },
      title_color: "#ffffff",
      description_color: "#bac6d1",
      button_color: "#226384",
      button_text_color: "#ffffff",
      player_controls_color: "#226384",
      created_by: 1001,
      id: "custom-ml-15",
    },
    button_style: 2,
    amazonmusic_url: "https://music.amazon.com/albums/B09X8VG4ZK",
    applemusic_url: "https://music.apple.com/album/1599023780",
    beatport_url: "https://www.beatport.com/release/evolution/3582815/",
    deezer_url: "https://www.deezer.com/album/280476492",
    spotify_url: "https://open.spotify.com/album/6pl1OHSkC0o9d602ZUXb8t",
    youtube_url: "https://www.youtube.com/watch?v=gY42WMUPQJE",
    id: 15,
    image: "https://i.scdn.co/image/ab67616d0000485105e9afee53ebf75a70ef15f6",
    url_part1_name: "ex",
    url: "https://musiclink.io/l/ex/evo",
    created: "2026-03-06T10:34:56.777Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#111827",
    header_gradient: {
      first_color: "#226384",
      second_color: "#0a0a14",
      direction: 3,
    },
    title_color: "#ffffff",
    description_color: "#bac6d1",
    button_color: "#226384",
    button_text_color: "#ffffff",
    player_controls_color: "#226384",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 12,
    url_part2: "hcn",
    preview_files: [
      {
        track_name: "Hurricane",
        artist_name: "Sean Joseph",
        url: "https://p.scdn.co/mp3-preview/48f4be0ca37fd87e98f847822e93174aa2b9b027?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Hurricane - Radio Edit",
        artist_name: "Sean Joseph",
        url: "https://p.scdn.co/mp3-preview/9dafd69c7a6747173c62c37533ee2ccd58febacd?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Sean Joseph",
    release_name: "Hurricane",
    ean: "4061798916979",
    image_big: "https://i.scdn.co/image/ab67616d0000b2737addbc7b142769f4b147c4ad",
    image_small: "https://i.scdn.co/image/ab67616d000048517addbc7b142769f4b147c4ad",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - Hurricane",
      header_color: "#1f6feb",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#e2d088",
        second_color: "#b0c1ce",
        direction: 2,
      },
      title_color: "#000000",
      description_color: "#030000",
      button_color: "#e2d088",
      button_text_color: "#000000",
      player_controls_color: "#e2d088",
      created_by: 1001,
      id: "custom-ml-16",
    },
    button_style: 1,
    applemusic_url: "https://music.apple.com/album/1559731004",
    beatport_url: "https://www.beatport.com/release/hurricane/3339689/",
    deezer_url: "https://www.deezer.com/album/216963842",
    spotify_url: "https://open.spotify.com/album/0gOsJ1ZF6ygRZqGmgRkgpl",
    youtube_url: "https://www.youtube.com/watch?v=RWPuiBlq80Q",
    id: 16,
    image: "https://i.scdn.co/image/ab67616d000048517addbc7b142769f4b147c4ad",
    url_part1_name: "beat",
    url: "https://musiclink.io/l/beat/hcn",
    created: "2026-02-17T10:43:55.143Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#1f6feb",
    header_gradient: {
      first_color: "#e2d088",
      second_color: "#b0c1ce",
      direction: 2,
    },
    title_color: "#000000",
    description_color: "#030000",
    button_color: "#e2d088",
    button_text_color: "#000000",
    player_controls_color: "#e2d088",
    amazonmusic_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 4,
    url_part2: "basti",
    preview_files: [
      {
        track_name: "Non Mi Basti Mai",
        artist_name: "Ballarak, Deborah de Luca",
        url: "https://p.scdn.co/mp3-preview/cdf3831aa3221892e70a3fb3f93d69966ab30535?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Ballarak, Deborah de Luca",
    release_name: "Non Mi Basti Mai",
    ean: "4255822348991",
    image_big: "https://i.scdn.co/image/ab67616d0000b27324b21498fa3288dfb377cb63",
    image_small: "https://i.scdn.co/image/ab67616d0000485124b21498fa3288dfb377cb63",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      id: "custom-ml-17",
      name: "Colors for Music Link - Non Mi Basti Mai",
      header_color: "#6d28d9",
      header_color_scheme: 2,
      header_gradient: {
        first_color: "#904242",
        second_color: "#000000",
        direction: 2,
      },
      title_color: "#ffffff",
      description_color: "#f8c1c1",
      button_color: "#904242",
      button_text_color: "#000000",
      player_controls_color: "#904242",
      created_by: 1001,
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B0DR2TKV1V",
    applemusic_url: "https://music.apple.com/album/1786566163",
    beatport_url: "https://www.beatport.com/release/non-mi-basti-mai/4867574/",
    deezer_url: "https://www.deezer.com/album/686481491",
    spotify_url: "https://open.spotify.com/album/6r1moz0BHsbq8EHs6jSRYU",
    traxsource_url: "https://www.traxsource.com/title/2431994/non-mi-basti-mai",
    youtube_url: "https://music.youtube.com/playlist?list=OLAK5uy_mu10V4NDU4S1GXtpF3QXjGN2KRVIWF_Zs",
    id: 17,
    image: "https://i.scdn.co/image/ab67616d0000485124b21498fa3288dfb377cb63",
    url_part1_name: "ex",
    url: "https://musiclink.io/l/ex/basti",
    created: "2026-01-31T10:44:49.638Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#6d28d9",
    header_gradient: {
      first_color: "#904242",
      second_color: "#000000",
      direction: 2,
    },
    title_color: "#ffffff",
    description_color: "#f8c1c1",
    button_color: "#904242",
    button_text_color: "#000000",
    player_controls_color: "#904242",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 5,
    url_part2: "aasb",
    preview_files: [
      {
        track_name: "And Then You Came",
        artist_name: "FERR, Ferry Corsten, Maria Marcus",
        url: "https://p.scdn.co/mp3-preview/7c4772ef578dcb5a443690eedef2bcfbc0a00c2d?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Evenfall",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/eb5d8ac05592fe2842b796168f5e8f8f0f232ff4?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Please",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/c9120dbf5595f21b8f3d35104c709839d90609c8?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Dulcinea",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/fd094de9c4e910be7998a5c61012e53c995bdb95?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Croi",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/2770d7806f701238b605f2aca27ad19f0447bcf5?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Arcane Soul",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/caf4d281e55ff2f7eebca960ac6a4934f6b08fbb?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "When Thoughts Become You",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/e033e5c118a5067e280af972cbffd4579dd047a1?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Encounter",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/16cbfa71b473a9b36f378f9f66738d67416dfa1b?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Opia",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/1634068bd85196bede7a52c0ad959a682a5ecd9b?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Caim",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/e642d96a53c7fa6d0994d5a2ec99e7a65623f23e?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Dark Water",
        artist_name: "FERR, Ferry Corsten, Geronimo Snijtsheuvel",
        url: "https://p.scdn.co/mp3-preview/161dd301af4d54c31f6a76278dd9328d57db184c?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Sehnsucht",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/60535362cf57c8bca829bc69fbf6c5f585984eec?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Closer",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/56a873ca2e59ce8b44558c2c87fb82cfebbca2b8?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Away",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/658021e7b054564a1a19fc8ecdc7471a17a460a2?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Sweven",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/fd3285522bea820adb2c17e88ac3a7008359729f?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Void",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/488b6c4d20ff2131ef3ece1e5b4b75c81683b46d?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Gravity Waves",
        artist_name: "FERR, Ferry Corsten, Geronimo Snijtsheuvel",
        url: "https://p.scdn.co/mp3-preview/52ba4652463843db107e59119073f3eef4872ebb?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Beyond The North Wind",
        artist_name: "FERR, Ferry Corsten",
        url: "https://p.scdn.co/mp3-preview/679b8d145078125cac830d2e9430e1ef4806566a?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "FERR, Ferry Corsten",
    release_name: "As Above So Below (Deluxe Version)",
    ean: "8718522320576",
    image_big: "https://i.scdn.co/image/ab67616d0000b27323fd0ee02780adf89706c1f2",
    image_small: "https://i.scdn.co/image/ab67616d0000485123fd0ee02780adf89706c1f2",
    other_url: "",
    color_scheme: 2,
    premade_color: null,
    custom_color: {
      name: "Colors for Music Link - As Above So Below (Deluxe Version)",
      header_color: "#111827",
      header_color_scheme: 2,
      header_gradient: {
        id: 2,
        first_color: "#111827",
        second_color: "#6b7280",
        direction: 2,
      },
      title_color: "#ffffff",
      description_color: "#d1d5db",
      button_color: "#374151",
      button_text_color: "#111827",
      player_controls_color: "#111827",
      created_by: 1001,
      id: "custom-ml-18",
    },
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B0FQ3927J7",
    applemusic_url: "https://music.apple.com/album/1538975493",
    beatport_url: "https://www.beatport.com/release/as-above-so-below-deluxe-version/3186102/",
    deezer_url: "https://www.deezer.com/album/184308622",
    spotify_url: "https://open.spotify.com/album/77Z0RXxgT4Qu5anSsMNmXn",
    youtube_url: "https://www.youtube.com/watch?v=qgkTljgS6E0",
    id: 18,
    image: "https://i.scdn.co/image/ab67616d0000485123fd0ee02780adf89706c1f2",
    url_part1_name: "sthx",
    url: "https://musiclink.io/l/sthx/aasb",
    created: "2026-01-15T10:45:53.940Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#111827",
    header_gradient: {
      id: 2,
      first_color: "#111827",
      second_color: "#6b7280",
      direction: 2,
    },
    title_color: "#ffffff",
    description_color: "#d1d5db",
    button_color: "#374151",
    button_text_color: "#111827",
    player_controls_color: "#111827",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 10,
    url_part2: "strings",
    preview_files: [
      {
        track_name: "Dhaani",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/f07f3f96e368a7d962d231fdac46de089a439753?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Najane Kyun",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/f69d4632500805b2944deae73a3d640176c13b04?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Kahani Mohabat Ki",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/1d33d422380a6442db669dc396329e0684e19f59?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Sohniyae",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/960a4078c2f100051eb0464c20dc4ed4dead3378?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Bolo Bolo",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/73434b45b94bc9cc6e7472ca1f9cce877627a5cf?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Chaaye Chaaye",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/128025bcbfc6f3049054ea47c2f84c7fecbdc851?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Mera Bichraa Yaar",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/d37520949e22bc71e0bde79e22d872208cb16fd2?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
      {
        track_name: "Pal",
        artist_name: "Strings",
        url: "https://p.scdn.co/mp3-preview/93e1d5a1b0d07201bb1cec48c71ba5a3e3d9c7c5?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Strings",
    release_name: "Dhaani",
    ean: "190394412098",
    image_big: "https://i.scdn.co/image/ab67616d0000b2731f173185cab0f0870090c8fa",
    image_small: "https://i.scdn.co/image/ab67616d000048511f173185cab0f0870090c8fa",
    other_url: "",
    color_scheme: 1,
    premade_color: 1,
    custom_color: null,
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B01DL6HIVS",
    applemusic_url: "https://music.apple.com/album/1097808924",
    deezer_url: "https://www.deezer.com/album/12744636",
    spotify_url: "https://open.spotify.com/album/1JV7W8JrdR7j6LRkAAk5cw",
    youtube_url: "https://www.youtube.com/watch?v=kAVAHLycSCE",
    id: 20,
    image: "https://i.scdn.co/image/ab67616d000048511f173185cab0f0870090c8fa",
    url_part1_name: "wave",
    url: "https://musiclink.io/l/wave/strings",
    created: "2025-12-29T09:44:00.000Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#1f6feb",
    header_gradient: {
      id: 1,
      first_color: "#1f6feb",
      second_color: "#0ea5e9",
      direction: 2,
    },
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#0ea5e9",
    button_text_color: "#ffffff",
    player_controls_color: "#0ea5e9",
    beatport_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
  {
    url_part1: 10,
    url_part2: "baari",
    preview_files: [
      {
        track_name: "Baari",
        artist_name: "Bilal Saeed, Momina Mustehsan",
        url: "https://p.scdn.co/mp3-preview/a21c0ab8ab966fbf903de1eee419b701c0ff49b6?cid=d5ac7a63a10c4d888b14f926a84ab1d4",
      },
    ],
    source: 2,
    artist_name: "Bilal Saeed, Momina Mustehsan",
    release_name: "Baari",
    ean: "5055964352523",
    image_big: "https://i.scdn.co/image/ab67616d0000b273525442e96f72e08c440b1dcb",
    image_small: "https://i.scdn.co/image/ab67616d00004851525442e96f72e08c440b1dcb",
    other_url: "",
    color_scheme: 1,
    premade_color: 2,
    custom_color: null,
    button_style: 1,
    amazonmusic_url: "https://music.amazon.com/albums/B09969KKH4",
    applemusic_url: "https://music.apple.com/album/1576212291",
    deezer_url: "https://www.deezer.com/album/243791412",
    spotify_url: "https://open.spotify.com/album/4AqwIHdf4s6gXHVcvwHsIu",
    youtube_url: "https://www.youtube.com/watch?v=915vvBqZWLU",
    id: 19,
    image: "https://i.scdn.co/image/ab67616d00004851525442e96f72e08c440b1dcb",
    url_part1_name: "wave",
    url: "https://musiclink.io/l/wave/baari",
    created: "2025-12-04T09:43:00.000Z",
    owner: "John Doe",
    preview_files_missing: false,
    header_color_scheme: 2,
    header_color: "#111827",
    header_gradient: {
      id: 2,
      first_color: "#111827",
      second_color: "#6b7280",
      direction: 2,
    },
    title_color: "#ffffff",
    description_color: "#d1d5db",
    button_color: "#374151",
    button_text_color: "#ffffff",
    player_controls_color: "#6b7280",
    beatport_url: "",
    junodownload_url: "",
    soundcloud_url: "",
    tidal_url: "",
    traxsource_url: "",
    anghami_url: "",
    bandcamp_url: "",
    boomplay_url: "",
    iheartradio_url: "",
    jiosaavn_url: "",
    sevendigital_url: "",
  },
];

export default mockMusicLinksData;
